import { useState } from "react";
import {
    Box,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    TextField,
    TextFieldProps,
    Typography,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import passwordCheck from "../../../public/images/password/Check-password.svg";

export default function PasswordInput(
    props: TextFieldProps & {
        label?: string;
        havePasswordChecker?: boolean;
        isValidPassword?: boolean;
        errortext: string;
        showvisibility: number;
        bordersx?: object;
    }
) {
    const { isValidPassword, havePasswordChecker, ...rest } = props;
    const [showPassword, setShowPassword] = useState<boolean>(false);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                width: "100%",
            }}
        >
            <InputLabel
                sx={{
                    fontSize: "0.875rem",
                    fontFamily: "Roboto",

                    color: "#023",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "160%",
                }}
                htmlFor={props.id}
            >
                {props.label}
            </InputLabel>
            <FormControl
                fullWidth={props.fullWidth ?? false}
                variant="standard"
            >
                <TextField
                    {...rest}
                    label=""
                    autoComplete="new-password"
                    type={showPassword ? "text" : "password"}
                    InputProps={{
                        // disableUnderline: true,
                        endAdornment: (
                            <InputAdornment position="end">
                                {havePasswordChecker && isValidPassword ? (
                                    <IconButton>
                                        <img
                                            src={passwordCheck}
                                            alt="password-check"
                                            height={20}
                                            width={20}
                                        />
                                    </IconButton>
                                ) : (
                                    <></>
                                )}
                                {props.showvisibility ? (
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() =>
                                            setShowPassword(!showPassword)
                                        }
                                    >
                                        {showPassword ? (
                                            <Visibility />
                                        ) : (
                                            <VisibilityOff />
                                        )}
                                    </IconButton>
                                ) : (
                                    <></>
                                )}
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        ".css-1j4jkw8-MuiInputBase-root-MuiOutlinedInput-root":
                            {
                                background: "none",
                            },

                        display: "flex",
                        flex: "1 0 0",
                        alignItems: "center",
                        gap: "0.5rem",
                        alignSelf: "stretch",
                        borderRadius: "1rem",
                        background: "#FFF",
                        width: "auto",
                        ...props.bordersx,
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                    }}
                />
            </FormControl>
            {props.errortext ? (
                <Typography
                    sx={{
                        fontSize: {
                            xs: "15px",
                            md: "17px",
                        },
                        fontWeight: "600",
                        fontFamily: "Roboto",
                        marginBottom: "10px",
                    }}
                    color="#E51846"
                >
                    {props?.errortext ?? ""}
                </Typography>
            ) : null}
        </Box>
    );
}
